import React from "react";

const Video =(props)=> {

        return (
            <div className="row justify-content-center">
                <div className="col-12 col-sm-10 col-md-8 col-lg-6 text-center m-4 ">
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe className="embed-responsive-item" src={props.election.configuration.video_url?props.election.configuration.video_url:"https://www.youtube.com/embed/qhCtA92V6PI?rel=0"} title="video"
                                allowFullScreen></iframe>
                    </div>
                </div>
            </div>);
    }


export default Video;